/**
 * Orders are known by two numbers: Medusa's sequential `display_id` (#50) and the
 * salon-facing `custom_display_id` (SS-26259126) that appears on the storefront,
 * in emails and in the note pushed to the supplier's Shopify. Medusa's admin
 * order type does not declare `custom_display_id`, so it is read through here.
 */
export type OrderDisplayIds = {
  display_id?: number | null
  custom_display_id?: string | null
}

export const getCustomDisplayId = (order: OrderDisplayIds): string | null =>
  order.custom_display_id || null

/** The SS- number when the order has one, otherwise `#display_id` (empty if neither is known). */
export const getOrderLabel = (order: OrderDisplayIds): string =>
  getCustomDisplayId(order) ??
  (order.display_id != null ? `#${order.display_id}` : "")
